import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, RootRef } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Button from '../../../../shared/components/Button';
import List from '../../../../shared/components/List';
import Paragraph from '../../../../shared/components/Paragraph';
import TwoCols from '../../../../shared/structure/TwoCols';
import VoiceAccordion from '../../../../shared/components/Accordion';
import Warning from './Warning';

const useStyles = makeStyles(() => ({
  link: {
    wordBreak: 'break-all',
  },
}));

function SendByUsualMail({
  copyLink,
  copyLinkText,
  handlePrint,
  isCopyLoading,
  isPrintLoading,
  link,
  printLink,
  printRef,
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <VoiceAccordion
        title={t('mail_post_title')}
        content={(
          <>
            <List>
              <li>{t('mail_post_instruction_1')}</li>
              <li>{t('mail_post_instruction_2')}</li>
              <li>{t('mail_post_instruction_3')}</li>
            </List>
            <Box p={5} pt={0} pb={0}>
              <Paragraph bold>
                {t('mail_post_instruction_address_1')}
                <br />
                {t('mail_post_instruction_address_2')}
              </Paragraph>
            </Box>
            <Paragraph>
              {t('mail_post_instruction_4')}
            </Paragraph>

            <TwoCols
              leftAlign="center"
              rightAlign="center"
              left={(
                <RootRef rootRef={printRef}>
                  <Button
                    background="blue"
                    small
                    text={t('mail_print_mail_button')}
                    onClick={(event) => handlePrint(event)}
                    isLoading={isPrintLoading}
                    href={printLink}
                  />
                </RootRef>
              )}
              right={(
                <>
                  {
                    link === '' ? t('mail_link_in_progress') : (
                      <Button
                        background="blue"
                        small
                        text={t('mail_copy_link_button')}
                        onClick={copyLink}
                        isLoading={isCopyLoading}
                      />
                    )
                  }
                  {copyLinkText && (
                    <Paragraph
                      textAlign="center"
                    >
                      <small className={classes.link}>
                        {t('mail_copy_link_done')}
                      </small>
                    </Paragraph>
                  )}
                </>
              )}
            />

            <Warning email />
          </>
        )}
      />
    </>
  );
}
SendByUsualMail.defaultProps = {
  copyLinkText: '',
  isPrintLoading: false,
  isCopyLoading: false,
  printLink: '',
  printRef: null,
};

SendByUsualMail.propTypes = {
  copyLink: PropTypes.func.isRequired,
  copyLinkText: PropTypes.string,
  handlePrint: PropTypes.func.isRequired,
  isCopyLoading: PropTypes.bool,
  isPrintLoading: PropTypes.bool,
  link: PropTypes.string.isRequired,
  printLink: PropTypes.string,
  printRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default SendByUsualMail;
